<template>
    <div class="order-edit-modal">
        <div class="order-edit-modal__deliveries order-edit-modal__deliveries--private private">
            <div class="order-edit-modal__deliveries__col-container">
                <div class="order-edit-modal__deliveries__col order-edit-modal__deliveries__col">
                    <div class="order-edit-modal__interval">
                        <h2 class="order-edit-modal__heading">Lieferungstag</h2>
                        <div v-if="!isDisabledMonday" class="radio">
                            <label :class="isDisabledMonday ? 'disabled-input' : ''">
                                <input
                                    :value="'monday'"
                                    :checked="privateDeliveryDay === 'monday'"
                                    :disabled="isDisabledMonday"
                                    name="private-delivery-day"
                                    type="radio"
                                    @change="updatePrivateDeliveryDay('monday')"
                                >
                                <span class="custom-radio" />
                                Montag
                            </label>
                        </div>
                        <div v-if="!isDisabledWednesday" class="radio">
                            <label :class="isDisabledWednesday ? 'disabled-input' : ''">
                                <input
                                    :value="'wednesday'"
                                    :checked="privateDeliveryDay === 'wednesday'"
                                    :disabled="isDisabledWednesday"
                                    name="private-delivery-day"
                                    type="radio"
                                    @change="updatePrivateDeliveryDay('wednesday')"
                                >
                                <span class="custom-radio" />
                                Mittwoch
                            </label>
                        </div>
                    </div>
                    <delivery-day
                        :day="privateDeliveryDay"
                        :orderable-intervals="orderableIntervals"
                        :orderable-baskets="orderableBaskets"
                        :intervals="intervals"
                        :baskets="baskets"
                        :set-delivery-interval="setDeliveryInterval"
                        :edit-basket="editBasket"
                        title="Lieferungsintervall"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

import DeliveryDay from './DeliveryDay.vue';
import BasketInput from './BasketInput.vue';

import filters from '../mixins/filters';

export default {
    components: {
        BasketInput,
        DeliveryDay,
    },
    mixins: [
        filters,
    ],
    data() {
        // only way to clone a state object...
        const { state } = this.$store;
        const baskets = _.cloneDeep(state.baskets);
        const intervals = _.cloneDeep(state.intervals);
        const privateDeliveryDay = state.privateDeliveryDay;
        const subscriptionType = state.subscriptionType;
        return {
            baskets: baskets[privateDeliveryDay],
            intervals: intervals[privateDeliveryDay],
            privateDeliveryDay,
            isDisabledMonday: false,
            isDisabledWednesday: false,
            subscriptionTypeId: subscriptionType,
        };
    },
    computed: {
        ...mapState({
            editModeVisible: state => state.editModeVisible,
            subscriptionTypes: state => state.orderable.product_groups,
            orderableIntervals: state => state.orderable.intervals,
        }),
        ...mapGetters([
            'orderableBaskets',
            'appetites',
            'subscriptionType',
        ]),
        initBaskets() {
            return this.$store.state.baskets;
        },
        initIntervals() {
            return this.$store.state.intervals;
        },
        initPrivateDeliveryDay() {
            return this.$store.state.privateDeliveryDay;
        },
    },
    watch: {
        initBaskets() {
            this.baskets = _.cloneDeep(this.initBaskets[this.privateDeliveryDay]);
        },
        initIntervals() {
            this.checkWednesdayAvailability();
            this.intervals = _.cloneDeep(this.initIntervals[this.privateDeliveryDay]);
        },
        initPrivateDeliveryDay() {
            this.privateDeliveryDay = this.initPrivateDeliveryDay;
        },
        subscriptionType() {
            this.init();
            this.checkWednesdayAvailability();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.subscriptionType.products[0].preferred_delivery_day) {
                const preferredDay = this.subscriptionType.products[0].preferred_delivery_day;
                await this.$store.commit('updatePrivateDeliveryDay', preferredDay === 1 ? 'monday' : 'wednesday');
            } else {
                if (!this.subscriptionType.products[0].delivery_days.some(p => p === 1)) {
                    this.isDisabledMonday = true;
                    this.isDisabledWednesday = true;
                    await this.$store.commit('updatePrivateDeliveryDay', 'wednesday');
                }
                if (!this.subscriptionType.products[0].delivery_days.some(p => p === 3)) {
                    this.isDisabledMonday = true;
                    this.isDisabledWednesday = true;
                    await this.$store.commit('updatePrivateDeliveryDay', 'monday');
                }
            }
            this.update();
        },
        checkWednesdayAvailability() {
            if (this.subscriptionType.products[0].delivery_days.some(p => p === 1)) {
                this.isDisabledMonday = false;
            } else {
                this.isDisabledMonday = true;
            }
            if (this.subscriptionType.products[0].delivery_days.some(p => p === 3)) {
                this.isDisabledWednesday = false;
            } else {
                this.isDisabledWednesday = true;
            }
        },
        basketsCount(id) {
            return this.baskets.filter(b => b.id === id).length;
        },
        toggleEditModalVisible() {
            this.$store.commit('toggleEditModalVisible');
        },
        update() {
            const { initBaskets, intervals, subscriptionTypeId, privateDeliveryDay } = this;
            let { baskets } = this;

            baskets = baskets.length ? baskets : initBaskets[privateDeliveryDay];
            // // send baskets to store
            this.$store.dispatch('saveEditPrivate', {
                baskets,
                intervals,
                subscriptionType: subscriptionTypeId,
                privateDeliveryDay,
            });

            // GTM VirtualPageview
            const { dataLayer } = window;
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'VirtualPageview',
                    virtualPageURL: '/de/bio-fur-dihei/abo-anpassen',
                    virtualPageTitle: 'Abo Bestellen Zuhause - Abo anpassen',
                });
            }
        },
        // updateActiveSubscriptionType(id) {
        //     this.subscriptionType = id;
        // },
        setDeliveryInterval(id) {
            this.intervals = id;
            this.update();
        },
        updatePrivateDeliveryDay(day) {
            this.privateDeliveryDay = day;
            this.update();
        },
        editBasket({ basket, value, removeallById }) {
            const { id } = basket;
            // add
            if (value > this.baskets.filter(b => b.id === id).length) {
                this.baskets = [...this.baskets, {
                    ...basket,
                }];
            } else if (removeallById) {
                // remove
                const idsToRemove = this.baskets.filter(b => b.id === id);
                this.baskets = idsToRemove;
            } else {
                const basketIndex = this.baskets.findIndex(b => b.id === id);
                this.baskets.splice(basketIndex, 1);
            }

            this.update();
        },
    },
};
</script>
<style scoped>
    .disabled-input {
        color: #818a91 !important;
    }
</style>



// WEBPACK FOOTER //
// EditPrivate.vue?645704b4